import script from "./Games.vue?vue&type=script&lang=ts&setup=true"
export * from "./Games.vue?vue&type=script&lang=ts&setup=true"

import "./Games.vue?vue&type=style&index=0&id=3c089bec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c089bec"]])

export default __exports__